import { doNotification } from "../../../components/toast/nofitication";
import { handleError } from "../../../helperFunctions";
import { BaseAPIResponse } from "../../../utils/types";
import { baseApi } from "../../api";
import {
  AddBankDetailsPayload,
  GetMemberBankAccountsResponse,
  GetPaymentLinkQuery,
  GetPaymentLinkResponse,
  SetupDirectDebit,
  SetupDirectDebitResponse,
  UserDebitCardsRespose,
  VerifyPayment,
} from "./payment.type";

export const paymentApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getMemberBankAccounts: builder.query<GetMemberBankAccountsResponse, void>({
      query: () => {
        return {
          url: `/Payment/BankDetail/Member`,
          method: "GET",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    deleteMemberBankAccount: builder.mutation<BaseAPIResponse, { id: number }>({
      query: (payload) => {
        return {
          url: `/Payment/BankDetail/Member`,
          method: "DELETE",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const resp = await queryFulfilled;

          if (resp.data.success) {
            doNotification("Bank information removed successfully", "success");
          }
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    addMemberBankDetails: builder.mutation<
      BaseAPIResponse,
      AddBankDetailsPayload
    >({
      query: (payload) => {
        return {
          url: `/Payment/BankDetail/Member`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const resp = await queryFulfilled;

          if (resp.data.success) {
            doNotification("Bank details updated successfully", "success");
          }
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    addCooperativeBankDetails: builder.mutation<
      BaseAPIResponse,
      AddBankDetailsPayload
    >({
      query: (payload) => {
        return {
          url: `/Payment/BankDetail/Cooperative`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const resp = await queryFulfilled;

          if (resp.data.success) {
            doNotification("Bank details updated successfully", "success");
          }
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    getUserDebitCards: builder.query<UserDebitCardsRespose, void>({
      query: () => {
        return {
          url: `/Payment/CardDetail/Member`,
          method: "GET",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    initiatePaystackCardTokenization: builder.mutation<
      GetPaymentLinkResponse,
      GetPaymentLinkQuery
    >({
      query: (params) => {
        return {
          url: `/Payment/Get/link`,
          method: "GET",
          params: params,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    verifyCardTokenization: builder.mutation<BaseAPIResponse, VerifyPayment>({
      query: (payload) => {
        return {
          url: `/Payment/CardDetail/Member`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, false);
        }
      },
    }),

    deleteDebitCard: builder.mutation<BaseAPIResponse, { id: number }>({
      query: (payload) => {
        return {
          url: `/Payment/CardDetail/Member`,
          method: "DELETE",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),

    setUpDirectDebit: builder.mutation<
      SetupDirectDebitResponse,
      SetupDirectDebit
    >({
      query: (payload) => {
        return {
          url: `/Payment/Add/DirectDebit`,
          method: "POST",
          body: payload,
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err, true);
        }
      },
    }),
  }),
});

export const {
  useDeleteMemberBankAccountMutation,
  useGetMemberBankAccountsQuery,
  useLazyGetMemberBankAccountsQuery,
  useAddCooperativeBankDetailsMutation,
  useAddMemberBankDetailsMutation,
  useGetUserDebitCardsQuery,
  useInitiatePaystackCardTokenizationMutation,
  useVerifyCardTokenizationMutation,
  useDeleteDebitCardMutation,
  useSetUpDirectDebitMutation,
} = paymentApi;
